import { render, staticRenderFns } from "./sorting.vue?vue&type=template&id=830c687a"
import script from "./sorting.vue?vue&type=script&lang=js"
export * from "./sorting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports